import { ed, EdState, INITIAL_ED_STATE } from "../ed";
import { DesktopState } from "@/components/desktopState";
import { processStory } from "@/utils/utils";
import answerNumStory1 from "./2139.txt";
import answerNumStory2 from "./115.txt";
import beginStory from "./begin.txt";
import fencesStory from "./fences.txt";
import inputStory from "./input.txt";
import ld2DotS from "./ld2.txt";
import edManualStory from "./man.txt";
import edReferenceStory from "./ref.txt";
import helpStory from "./CYO-HELP.txt";
import buildFile from "./build.txt";
import chkfnc from "./chkfnc.txt";

const initialDesktopState: DesktopState = {
  tool: "HAND",
  volume: "NOISY",
  teletype: {
    line: "",
    activePaper: ["1", "Your eyes are closed. Hit 3 and <Enter> to open them."]
  },
  pinboard: {
    papers: [
    ]
  },
  help: helpStory,
  turboSpeed: 80,
  version: 2
};



let initialEdState: EdState = ed({
  ...INITIAL_ED_STATE,
  files: {
    "begin.txt": processStory(beginStory),
    "input.txt": processStory(inputStory),
    "fences.txt": processStory(fencesStory),
    "2139.txt": processStory(answerNumStory1),
    "115.txt": processStory(answerNumStory2),
    "2088.txt": processStory(answerNumStory2),
    "man.txt": processStory(edManualStory),
    "ref.txt": processStory(edReferenceStory),
    "ld2.s": processStory(ld2DotS),
    "chkfnc": chkfnc,
    "build": buildFile,
  }
}, "e begin.txt")[0];

export const cyo = {
  id: "cya",
  initialDesktopState,
  initialEdState
};
